export { default } from './components/Icon';


//////////////////
// WEBPACK FOOTER
// /Users/shuai/Documents/github/ant-design-pro-site/scaffold/node_modules/_@ant-design_icons-react@1.1.2@@ant-design/icons-react/es/index.js
// module id = 273
// module chunks = 0